import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-style-two',
  templateUrl: './video-style-two.component.html',
  styleUrls: ['./video-style-two.component.scss']
})
export class VideoStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
